import {GET, POST} from "@/services/gateway";

const getBackupEvents = () => {
  return GET('dashboard/entraid/backup-events');
}

const list = (data) => {
  return POST('dashboard/entraid/backup-events', data);
}

const getBackupItems = () => {
  return GET('dashboard/entraid/backup-items');
}

export {
  getBackupEvents,
  getBackupItems,
  list,
}
